import { useEffect, useRef } from "react";
import { Card, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import { namespaces } from "../../i18n/i18n.constants";
import { TableSearchPanelProps } from "./TableSearchPanelProps";
import "./TableSearchPanel.scss";

const TableSearchPanel = ({
    onSearch,
    headerAction,
    contentBelow,
    searchPlaceholder,
    searchAriaLabel,
    className = "",
    debounceMs = 0,
}: TableSearchPanelProps) => {
    const { t } = useTranslation(namespaces.common);
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }, []);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (debounceMs <= 0) {
            onSearch(inputValue);
            return;
        }

        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => onSearch(inputValue), debounceMs);
    };

    const defaultPlaceholder = t("elements.search");
    const placeholder = searchPlaceholder || defaultPlaceholder;
    const ariaLabel = searchAriaLabel || placeholder;

    return (
        <Card.Header className={`search-panel-card-header py-3 px-0 ${className}`}>
            <div className="search-panel px-3">
                <div className="search-panel-main d-flex flex-wrap">
                    <div className="d-flex flex-grow-1">
                        <Form.Control
                            type="text"
                            placeholder={placeholder}
                            aria-label={ariaLabel}
                            className="search-input custom-form-control"
                            onChange={handleInputChange}
                        />
                        <div className="search-icon">
                            <FaSearch />
                        </div>
                    </div>
                    {headerAction && (
                        <div className="header-action-wrapper">
                            {headerAction}
                        </div>
                    )}
                </div>
                {contentBelow && (
                    <div className="search-panel-below">
                        {contentBelow}
                    </div>
                )}
            </div>
        </Card.Header>
    );
};

export default TableSearchPanel;
